export default "__VITE_ASSET__DbpnNHwk__"